import * as e from "react";
import s from "../lib/IconBase.es.js";
import n from "../defs/DotsThreeOutline.es.js";
const o = e.forwardRef((t, r) => /* @__PURE__ */ e.createElement(s, { ref: r, ...t, weights: n }));
o.displayName = "DotsThreeOutlineIcon";
const m = o;
export {
  m as DotsThreeOutline,
  o as DotsThreeOutlineIcon
};
